import React from 'react'
import { withTrans } from '../i18n/withTrans'
import Navigation from './SiteHeader/SiteHeader'
import Footer from './SiteFooter/SiteFooter'
import PropTypes from 'prop-types'
import cx from 'classnames'

const Layout = ({ children, navConfig, footerConfig }) => {
  const SITE = process.env.GATSBY_COUNTRY || ''

  return (
    <>
      <Navigation navConfig={navConfig} />
      <main className={cx("relative bg-white", SITE.includes('LEAD') ? "selection:text-charcoal-500 selection:bg-lime-500" : '')} id="main">
        {children}
      </main>
      <Footer footerConfig={footerConfig} />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  navConfig: PropTypes.object.isRequired,
}

export default withTrans(Layout)
